export default "__VITE_ASSET__FuAVqjQG__"